<template>
  <div class="rich-text-box-container">
    <div class="editor" ref="editor"></div>
    <div class="footer">
      <el-button type="primary" @click="saveData">保存</el-button>
      <el-button @click="closeDialog">取消</el-button>
    </div>
  </div>
</template>

<script>
import tokenStorage from '@/plugins/tokenStorage'
import Editor from 'wangeditor'
export default {
  name: 'rich-text-box',
  props: ['data'],
  data () {
    return {
      editor: undefined
    }
  },
  methods: {
    initRichBox () {
      let self = this
      let token = tokenStorage.getToken()
      this.editor = new Editor(this.$refs.editor)
      this.editor.customConfig.showLinkImg = false
      this.editor.customConfig.zIndex = 100
      // 定义图片接受file name 名称后台定义的file
      this.editor.customConfig.uploadFileName = 'image'
      this.editor.customConfig.uploadImgHeaders = {
        'Authorization': token
      }
      this.editor.customConfig.uploadImgServer = `/shared-api/files/uploadImage`
      this.editor.customConfig.uploadImgParams = {type: 'USER'}
      this.editor.customConfig.uploadImgHooks = {
        error (xhr, editor) {
          this.$message.error('上传失败')
        },
        customInsert (insertImg, result, editor) {
          let url = self.getDownLoadUrl(result.data)
          insertImg(url)
        }
      }
      this.editor.customConfig.onchange = html => {
        // 富文本框的值修改触发
        this.data.richValue = html
      }
      this.editor.create()
    },
    saveData () {
      if (this.data.richValue.trim() === '') {
        return this.$message.info('请填写富文本框内容！')
      }
      this.$emit('addControls', this.data, true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    getDownLoadUrl (path) {
      return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') + path : path.includes('SYSTEM') ? sessionStorage.getItem('ossDownloadUrl') + path : path
    }
  },
  mounted () {
    this.initRichBox()
    this.$refs.editor.children[1].style.height = '425px'
    if (this.data.richValue) {
      this.editor.txt.html(this.data.richValue)
    }
  }
}
</script>

<style lang="scss">
  .rich-text-box-container {
    width: 100%;
    height: 100%;
    padding: 18px 37px;
    .footer {
      padding-top: 37px;
      text-align: center;
      .el-button--primary {
        margin-right: 52px;
      }
      .el-button {
        padding: 0;
        width: 78px;
        height: 26px;
        line-height: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/rich-text-box.vue